import { useEffect, useState } from "react";

const GoogleCallbackPage = () => {
  const [message, setMessage] = useState("Finishing Google sign-in...");

  useEffect(() => {
    const parseParams = () => {
      const hash = window.location.hash?.replace(/^#/, "");
      const search = window.location.search?.replace(/^\?/, "");
      const source = hash || search || "";
      const params = new URLSearchParams(source);
      return {
        idToken: params.get("id_token"),
        state: params.get("state"),
        error: params.get("error"),
      };
    };

    const data = parseParams();
    const payload = { type: "wayli-google-oauth", ...data };

    const storedState = sessionStorage.getItem("wayli.google.oauth.state");
    const intent = sessionStorage.getItem("wayli.google.oauth.intent") || "login";

    try {
      if (data.state && storedState && data.state !== storedState) {
        setMessage("Google sign-in state mismatch.");
        return undefined;
      }

      if (window.opener) {
        window.opener.postMessage(payload, window.location.origin);
        setMessage(data.error ? "Google sign-in was cancelled." : "Signed in. You can close this window.");
        const timer = window.setTimeout(() => {
          window.close();
        }, 1200);
        return () => window.clearTimeout(timer);
      }

      if (data.error) {
        setMessage("Google sign-in was cancelled.");
        return undefined;
      }

      if (data.idToken) {
        sessionStorage.setItem("wayli.google.oauth.token", data.idToken);
        sessionStorage.setItem("wayli.google.oauth.state", data.state || "");
        sessionStorage.setItem("wayli.google.oauth.intent", intent);
        setMessage("Signed in. Redirecting...");
        const next = intent === "register" ? "/register" : "/login";
        const timer = window.setTimeout(() => {
          window.location.href = next;
        }, 600);
        return () => window.clearTimeout(timer);
      }

      setMessage("No Google token received.");
      return undefined;
    } catch {
      setMessage("Could not notify the main window. Please close this tab.");
      return undefined;
    }
  }, []);

  return (
    <div style={{ fontFamily: "sans-serif", padding: "2rem", textAlign: "center" }}>
      <p>{message}</p>
    </div>
  );
};

export default GoogleCallbackPage;
